import Api from '@/services/api';
import {removeEmptyParams} from '@utils';

export default {
  housekeeperAccommodations(filter) {
    return Api()
      .get('/housekeeperaccommodations', {params: removeEmptyParams(filter)})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  housekeeperAccommodationsForHousekeeper(housekeeperId) {
    return Api()
      .get('/housekeeperaccommodations/' + housekeeperId, {})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  housekeeperAccommodationsHistory(housekeeperId) {
    return Api()
      .get('/housekeeperaccommodations/history/' + housekeeperId, {})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  autocomplete(filter) {
    return Api()
      .get('/housekeeperaccommodations/autocomplete', {params: removeEmptyParams(filter)})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  formatRes(e) {
    return e;
  },
};
